















































































import Vue from 'vue'
import { mapGetters } from 'vuex'

import { NetworkService } from '@/services/NetworkService'

import CreateProductDialog from '../../components/admin/CreateProductDialog.vue'
import EditProductDialog  from '../../components/admin/EditProductDialog.vue'

/* eslint-disable */ 
import { Product } from '../../models/Product'
/* eslint-enable */ 


export default Vue.extend({
  data: () => ({
    editProductDialog: false as boolean,
    createProductDialog: false as boolean,
    deleteProductDialog: false as boolean,
    manufacturerOverrideDialog: false as boolean,
    search: '' as string,
    selectedProduct: null as any,
    headers: [
      {
        text: 'Name',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      { text: 'Product Number', value: 'number' },
      { text: 'Price', value: 'price' },
      { text: 'FRT', value: 'frt'},
      { text: '', value: 'actions', sortable: false}
    ],
    options: {
    },
    products: [] as Product[],
    totalProducts: 0,
    loading: false,
  }),
  components: {
    CreateProductDialog,
    EditProductDialog,
  },
  computed: {
    ...mapGetters({
      make: 'makes/currentMake',
      dealerId: 'dealers/currentDealerId',
    }),
    isMobile() : boolean {
      const { xs, sm } = this.$vuetify.breakpoint
      return xs || sm
    },
  },
  methods: {
    closeDealerDialog(resetProducts: boolean) : void {
      this.editProductDialog = false
      this.createProductDialog = false
      this.selectedProduct = false
      if (resetProducts) this.getDealerProducts()
    },
    editItem(item: Product) {
      this.selectedProduct = item
      this.editProductDialog = true
    },
    deleteItem(item: Product) {
      this.selectedProduct = item
      this.deleteProductDialog = true
    },
    async deleteProduct() {
      this.loading = true
      await NetworkService.delete(
        process.env.VUE_APP_API_BASE_URL + 
        '/api/v1/auth/products/' + this.selectedProduct.id
      )
      this.loading = false
      this.deleteProductDialog = false
      this.getDealerProducts()
    },
    async getDealerProducts() {
      this.loading = true
      const res = await Product.getDealerProducts('Dealer', this.make.id, this.dealerId, this.options, this.search)
      this.products = res.products
      this.totalProducts = res.total
      this.loading = false
    },
    createNewProduct() {
      this.createProductDialog = true
    }
  },
})
